/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import * as types from './mutation-types';
import API from '@/services/commonApi';
import { LOGOUT, RESENDEMAIL, PROJECTFAVOURITE, BROKERLOGINCUSTOMER, GETUSERINFO } from '@/utils/endpoint';
import store from '../..';

export const check = ({ commit }) => {
  commit(types.CHECK);
};

export const login = ({ commit }, payload) => {
  commit(types.LOGIN, payload);
  store.dispatch('auth/getUserInfo');
};

export const logout = ({ commit }, payload) => {
  API.post(LOGOUT)
    .then(() => {
      commit(types.LOGOUT);
      if (payload && payload.cbSuccess)
        payload.cbSuccess();
    })
    .catch((error) => {
      commit(types.LOGOUT);
      if (payload && payload.cbSuccess)
        payload.cbSuccess();
      console.log(error);
    });
};

export const updateBrokerCustomers = ({ commit }, payload) => {
  commit(types.UPDATEBROKERCUSTOMERS, payload);
};

export const addBrokerCustomer = ({ commit }, payload) => {
  commit(types.ADDBROKERCUSTOMER, payload);
};

export const saveProfile = ({ commit }, payload) => {
  commit(types.PROFILESAVE, payload);
};

export const updateVerifiedState = ({ commit }, payload) => {
  commit(types.UPDATEVERIFIED, payload);
};

export const resendVerifiactionMail = ({ _commit }, payload) => {
  API.post(RESENDEMAIL, { email: payload.email })
    .then(() => {
      payload.cb_success();
    })
    .catch((error) => {
      payload.cb_error(error);
      console.log(error);
    });
};
export const addFavProjects = ({ _commit }, payload) => {
  API.post(PROJECTFAVOURITE, payload.data)
    .then(() => {
      if (payload.cb_success)
        payload.cb_success();
    })
    .catch((error) => {
      payload.cb_error(error);
    });
};
export const deleteFavProjects = ({ _commit }, payload) => {
  API.deleteWithParams(PROJECTFAVOURITE, payload.data)
    .then(() => {
      if (payload.cb_success)
        payload.cb_success();
    })
    .catch((error) => {
      payload.cb_error(error);
    });
};

export const loginCustomer = ({ commit }, payload) => {
  API.post(BROKERLOGINCUSTOMER, payload.data)
    .then((data) => {
      commit(types.LOGIN, data);
      if (payload && payload.cbSuccess)
        payload.cbSuccess(data);
    })
    .catch((error) => {
      if (payload && payload.cbError)
        payload.cbError(error);
      console.log(error);
    });
};

const updateFav = ({ commit }, payload) => {
  commit(types.UPDATEFAV, payload);
};

const getUserInfo = ({ commit }) => {
  API.get(GETUSERINFO)
    .then((response) => {
      commit(types.SETUSERINFO, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

export default {
  check,
  login,
  logout,
  updateBrokerCustomers,
  addBrokerCustomer,
  saveProfile,
  updateVerifiedState,
  resendVerifiactionMail,
  addFavProjects,
  deleteFavProjects,
  loginCustomer,
  updateFav,
  getUserInfo,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js